module.exports = __webpack_public_path__ + "static/media/name.f735f8f6.svg";